define([], () => {
    const faq = {sections: []};

    function single(entries) {
        if (entries.length !== 1) {
            throw new Error(`Expected a single element but got ${entries}`);
        }
        return entries[0];
    }

    return {
        $get: () => {
            return {
                getAllSections: () => {
                    return faq.sections;
                },
                getLinkContent: id => {
                    const sectionContent = faq.sections
                        .filter(section => section.id === id)
                        .map(section => section.title);

                    const topicContent = faq.sections.map(section => section.topics)
                        .reduce((flat, item) => flat.concat(item), [])
                        .filter(topic => topic.id === id)
                        .map(topic => topic.inlineQuestion);

                    return single(sectionContent.concat(topicContent));
                }
            };
        },

        setSections: sections => {
            faq.sections = sections;
        }
    };
});



// WEBPACK FOOTER //
// ../common/js/src/edge/platform/faq/FaqService.js